import { render, staticRenderFns } from "./AxTempStaffNewDialog.vue?vue&type=template&id=dc5f9dde&scoped=true"
import script from "./AxTempStaffNewDialog.vue?vue&type=script&lang=ts"
export * from "./AxTempStaffNewDialog.vue?vue&type=script&lang=ts"
import style0 from "./AxTempStaffNewDialog.vue?vue&type=style&index=0&id=dc5f9dde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5f9dde",
  null
  
)

export default component.exports